/**
 * Formatea un monto en pesos colombianos, ej. `$16.000`. Acepta el valor tal
 * como llega del backend (número o string, por los campos `Decimal` de
 * Prisma que a veces se serializan como string — ver PROGRESS.md 5b/7).
 */
export function formatearMoneda(valor: number | string | null | undefined): string {
  return `$${Number(valor ?? 0).toLocaleString("es-CO")}`;
}

export const ZONA_HORARIA_COLOMBIA = "America/Bogota";

/**
 * Formatea fecha y hora completa en zona horaria oficial Colombia (America/Bogota).
 * Por defecto: "25/9/2026, 10:15:00 p. m." o según opciones de Intl.
 */
export function formatearFechaHora(
  fecha: Date | string | number | null | undefined,
  opciones?: Intl.DateTimeFormatOptions
): string {
  if (!fecha) return "";
  const d = typeof fecha === "object" ? fecha : new Date(fecha);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleString("es-CO", {
    timeZone: ZONA_HORARIA_COLOMBIA,
    ...opciones,
  });
}

/**
 * Formatea únicamente la fecha (día/mes/año) en zona horaria Colombia.
 */
export function formatearFecha(
  fecha: Date | string | number | null | undefined,
  opciones?: Intl.DateTimeFormatOptions
): string {
  if (!fecha) return "";
  const d = typeof fecha === "object" ? fecha : new Date(fecha);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleDateString("es-CO", {
    timeZone: ZONA_HORARIA_COLOMBIA,
    ...opciones,
  });
}

/**
 * Formatea únicamente la hora (horas:minutos) en zona horaria Colombia.
 */
export function formatearHora(
  fecha: Date | string | number | null | undefined,
  opciones?: Intl.DateTimeFormatOptions
): string {
  if (!fecha) return "";
  const d = typeof fecha === "object" ? fecha : new Date(fecha);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleTimeString("es-CO", {
    timeZone: ZONA_HORARIA_COLOMBIA,
    ...opciones,
  });
}

